import { useTranslation } from 'react-i18next';
import { useState, useContext, useMemo, useCallback, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Context } from '../../../index';
import time from '../../../hooks/timeFormat'
import Loader from '../../Loaders/LoaderKitsProfile'
import './kits.css'
import NotFound from '../../Other/NotFound';
import Tippy from '@tippyjs/react';

function KitItem({item, qnty, setKitsImages, kitsImages}:any) {
    const { t } = useTranslation();
    const {store} = useContext(Context);

    const imageLoaded = kitsImages?.includes(item);

    return (
        <Tippy delay={150}
            content={
                <div className='c-grey-250'>{t(`items.${item}`)}</div>
            }
        >
            <div className={`item-1 kit__item ${!imageLoaded ? 'loading':''}`}>
                <div className="kit__item__image_wrap">
                    <img src={store.resizeImg(`${item}.png`)} alt="" className="kit__item__image" 
                        onLoad={() => setKitsImages(item)}
                        style={{
                            opacity: imageLoaded ? 1: 0,
                        }}
                    />
                </div>
                <div className="kit__item__qnty">x{new Intl.NumberFormat('ru-RU').format(Math.floor(qnty))}</div>
            </div>
        </Tippy>
    )
}

function Body() {
    const { t } = useTranslation();
    const {store} = useContext(Context);
    const {kits, isKitsLoaded} = store;
    const [serverGroup, setServerGroup]  = useState('modded_x5');
    const [kitsGroup, setKitsGroup]  = useState('default');

    const [kitsImages, setKitsImages] = useState<string[]>([]);

    const setImageLoaded = useCallback((shortname: string) => {
        setKitsImages(prev => ([ ...prev, shortname ]));
    }, []);

    return(
        <main>
            <div className="xbox__body kits">
                { isKitsLoaded ?
                    Object.keys(kits).length > 0 ?
                    <div className="xbox__div-1 kits__table">
                        <nav className="kits__chooseServer__list">
                            {Object.keys(kits).map((server:any) => (
                                <button className={serverGroup === server ? "button-1 kits__chooseServer__server active" : "button-1 kits__chooseServer__server"} key={'chooseserver'+server} 
                                    onClick={e => {
                                        setKitsGroup(kits?.[server][0].group)
                                        setServerGroup(kits?.[server][0].servers)}
                                    }>
                                    <div className="kits__chooseServer__group_name">{t(`servers.group.${kits?.[server][0].servers}`)}</div> 
                                </button>
                            ))}
                        </nav>
                        <nav className="kits__chooseGroup">
                            {kits?.[serverGroup]?.map((kit:any, i:number) => (
                                    <button className={kitsGroup===kit.group ? "button-1 kits__chooseKit active" : "button-1 kits__chooseKit"} key={kit?.id + i} onClick={e => setKitsGroup(kit.group)}>
                                        <div className="kits__chooseKit_groupname">{t(`kits.group.${kit.group}`)}</div>
                                    </button>
                                )
                            )}
                        </nav>
                        <div className="kit__group">
                            {kits?.[serverGroup]?.map((group:any) => {
                                if (group.group===kitsGroup) return(
                                    group.kits.map((kit:any, i: number) => (
                                        <div className="kit" key={group.group + kit.name + i}>
                                            <div className="kit__group__header">
                                                <div className="kit__group__title">{t(`kits.${kit.name}`)}</div>
                                                <div className="kit__group__cooldown">
                                                    <svg fill="#ccc" className="kit__group__coldown__svg" viewBox="-0.72 -0.72 25.44 25.44" id="Outline" xmlns="http://www.w3.org/2000/svg" stroke="#ccc"><g id="SVGRepo_iconCarrier"><path d="M12,6a1,1,0,0,0-1,1v5a1,1,0,0,0,.293.707l3,3a1,1,0,0,0,1.414-1.414L13,11.586V7A1,1,0,0,0,12,6Z M23.812,10.132A12,12,0,0,0,3.578,3.415V1a1,1,0,0,0-2,0V5a2,2,0,0,0,2,2h4a1,1,0,0,0,0-2H4.827a9.99,9.99,0,1,1-2.835,7.878A.982.982,0,0,0,1,12a1.007,1.007,0,0,0-1,1.1,12,12,0,1,0,23.808-2.969Z"></path></g></svg>
                                                    <div className="kit__group__coldown__time">{ kit.once ? t('kits.categoryTime_limit_one') : time(kit.cooldown) }</div>
                                                </div>
                                                {kit.wipeblock>0 && 
                                                <div className="kit__group__cooldown afterWipeBlock" title={t('kits.afterWipeBlockTime')}>
                                                    <svg fill="#ccc" className="kit__group__coldown__svg" viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg" stroke="#ccc"><g id="SVGRepo_iconCarrier"><path d="M500 930q-117 0-217-59-97-57-154-154-59-100-59-217t59-217q57-97 154-154 100-59 217-59t217 59q97 57 154 154 59 100 59 217t-59 217q-57 97-154 154-100 59-217 59zM320 760q39 28 85.5 42.5T500 817q86 0 160-44 71-42 113-113 44-74 44-160 0-48-14.5-94.5T760 320zm180-577q-86 0-160 44-71 42-113 113-44 74-44 160 0 48 14.5 94.5T240 680l440-440q-39-28-85.5-42.5T500 183z"></path></g></svg>
                                                    <div className="kit__group__coldown__time">{ time(kit.wipeblock) }</div>
                                                </div>}
                                            </div>
                                            <div className="kit__group__items">
                                                {
                                                    kit.items.map((item:any, j: number) => (
                                                        <KitItem item={item.shortname} qnty={item.qnty} key={group.group+kit.name+item.shortname+j} 
                                                            setKitsImages={setImageLoaded}
                                                            kitsImages={kitsImages}
                                                        />
                                                    ))
                                                }
                                            </div>
                                        </div>
                                    ))
                                )
                            })}
                        </div>
                    </div>
                    :
                    <div className="xbox__div-1 kits__table">
                        <NotFound 
                            subtitle={t('kits.not_found.subtitle')}
                        />
                    </div>
                :
                <Loader />}
            </div>
        </main>
    )
}
export default observer(Body)